export default __webpack_public_path__ + "static/media/key-vertical.ad287930.svg";